import { DeviceInfo } from "./device-info";
import { GlobalSettings } from "./global-settings";
import { UNCSettings } from "./uncsettings";
import { v4 as uuid } from 'uuid'; 
import { KeyThresholds } from "./instrument-connection";

export const FACTORY_SETTINGS = [
    "aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee"
];

export class Backup {

    id: string = uuid();
    name: string | undefined = undefined;
    
    majorVersion: number = 0;  
    minorVersion: number = 0;  

    automatic: boolean = false;

    date: Date = new Date();

    device: DeviceInfo | undefined;
    
    unc: UNCSettings | undefined;

    sensorThresholds?: KeyThresholds;
    
    globalSettings: GlobalSettings | undefined;

    get isFactorySetting() : boolean {
        return FACTORY_SETTINGS.contains(this.id);
    }
}
